"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Question = void 0;

var _react = _interopRequireDefault(require("react"));

var _stars = _interopRequireDefault(require("./stars.js"));

require("@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css");

require("@ta-interaktiv/semantic-ui/semantic/dist/components/table.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

require('../style/styles.css');

/**
 * Render a single user feedback question.
 */
var Question =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Question, _React$Component);

  function Question() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Question);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Question)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      rating: -1
    };

    _this.handleClick = function (event) {
      event.preventDefault();
      event.stopPropagation(); // console.log(this.props.question + ': ' + event.currentTarget.getAttribute('data-starnumber'))
      // Sets the rating state from the star clicked in Stars component

      if (!_this.props.votingIsOver) {
        _this.setState({
          rating: event.currentTarget.getAttribute('data-stariterationcount')
        });

        _this.props.ratingHandler(_this.props.question, event.currentTarget.getAttribute('data-starnumber'));
      }
    };

    return _this;
  }

  _createClass(Question, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("tr", {
        className: "mobile no padding",
        style: {
          color: this.props.fontColor,
          border: 'none !important',
          fontFamily: 'Benton Sans Cond, sans-serif'
        }
      }, _react.default.createElement("td", {
        style: {
          width: '60%'
        }
      }, this.props.question), _react.default.createElement("td", {
        className: "stars ".concat(window.outerWidth >= 599 ? 'right aligned' : '')
      }, _react.default.createElement(_stars.default, {
        clickHandler: this.handleClick,
        starAmount: this.props.starAmount,
        fontColor: this.props.fontColor,
        starColor: this.props.starColor,
        rating: this.state.rating,
        votingIsOver: this.props.votingIsOver,
        averageRating: this.props.averageRating,
        ownRatingStarAmount: this.props.ownRatingStarAmount,
        ratingCount: this.props.ratingCount,
        starIcon: this.props.starIcon,
        inverted: this.props.inverted,
        theme: this.props.theme
      })));
    }
  }]);

  return Question;
}(_react.default.Component);

exports.Question = Question;
var _default = Question;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ta-interaktiv/react-user-feedback/dist/question.js
// module id = 450
// module chunks = 0